/**
 * Who is looking, in the terms the catalog filters on.
 *
 * Reads the whole resolved feature map off auth state rather than calling
 * `useFeature` once per flag: the catalog's gating list is data, and a hook
 * per entry would be a hook inside a loop — one new gated topic away from
 * breaking the rules of hooks.
 */

import { useMemo } from 'react';
import { useAuth } from '@modules/auth';
import type { LearnRole, LearnViewer } from '../content/catalog';

export function useLearnViewer(): LearnViewer {
  const { user } = useAuth();
  const role = (user?.role as LearnRole) || 'user';
  const features = user?.features;
  return useMemo(
    () => ({ role, hasFlag: (f: string) => features?.[f] === true }),
    [role, features],
  );
}
